module.exports = __webpack_public_path__ + "img/build1010.1b27edd7.png";